export default () =>{
    const addressWrappers = document.querySelectorAll('.address');
    
    addressWrappers.length >0 ? addressHandle():false;

    function addressHandle(){
        //#region edit Adress
            const editButton = document.querySelectorAll('.address-edit-toggle');
            editButton.forEach(button =>{
                button.addEventListener('click', (e)=>{
                    const formId = e.target.dataset.formId;
                    document.querySelector('#EditAddress_' + formId).classList.toggle('active');
                    setTimeout(() => {
                        document.querySelector('#EditAddress_' + formId).closest('.account-content').style.height =  document.querySelector('.account-content__tab').offsetHeight + 'px'
                    }, 500);
                })
            })
        //#endregion
        
        //#region Add new address
            const addNewAddress = document.querySelector('.newAddressBox');

            addNewAddress?addNewAddressFunction():false;

            function addNewAddressFunction(){
                const addButton = addNewAddress.querySelector('.address-add');
                const form = addNewAddress.querySelector('#AddressNewForm');
                const cancel = addNewAddress.querySelector('.address-new-cancel')
                addButton.addEventListener('click', ()=>{
                    form.classList.add('visible');
                    addButton.style.display = 'none';
                    setTimeout(() => {
                        addButton.closest('.account-content').style.height =  document.querySelector('.account-content__tab').offsetHeight + 'px'
                    }, 500);
                })
                cancel.addEventListener('click', ()=>{
                    form.classList.remove('visible');
                    addButton.style.display = 'inline-block';
                    setTimeout(() => {
                        addButton.closest('.account-content').style.height =  document.querySelector('.account-content__tab').offsetHeight + 'px'
                    }, 500);
                })
            }
        //#endregion
        
        // #region delete address
            document.querySelectorAll('.address-delete-form').forEach(deleteForm => {
                deleteForm.addEventListener('submit', event => {
                    const confirmMessage = event.target.getAttribute('data-confirm-message');
            
                    if (!window.confirm(
                        confirmMessage || 'Are you sure you wish to delete this address?'
                        )
                    ) {
                    event.preventDefault();
                }
                });
            });
        //#endregion
    }
}